<template>
	<div>
		<div v-show="isButtonFull">
			<div class="mt-2 flex flex-col space-y-3">
				<div
					class="w-fit cursor-pointer rounded bg-gray-100 px-2 py-1 transition-all duration-200 hover:bg-carClarity-50"
					@click="launchWidget"
				>
					<p class="text-xsm text-gray-700">
						View finance breakdown
						<sup>^</sup>
					</p>
				</div>
				<div class="flex items-center space-x-2">
					<span class="text-xs">Powered by</span>
					<CarbarImage
						image="img/logo-carclarity.webp"
						image-width-class="w-[80px]"
						alt-text="Car Clarity Logo"
					/>
				</div>
			</div>
		</div>
		<div
			v-show="!isButtonFull"
			class="rounded bg-gray-100 px-3 py-1 transition-all duration-200 hover:bg-gray-300"
		>
			<LinkWithIcon
				:icon-on-left="false"
				class="cursor-pointer no-underline"
				@click="launchWidget"
			>
				<template #icon>
					<IconMoreInfo />
				</template>
				<p class="text-xsm text-gray-700">
					Finance from
					<span>
						{{ formatCurrency(loanDetails.weekly_loan_payment) }}
						per week
					</span>
				</p>
			</LinkWithIcon>
		</div>

		<ClientOnly>
			<LazyModalsFlexiModal
				ref="carClarityRef"
				:show="showCarClarityModal"
				:is-custom="true"
				:inner-bg-color="'bg-carClarity-50'"
				:inner-padding="'p-4'"
				:custom-size="'md:min-w-[600px]'"
				@close-modal="resetCarClarity"
			>
				<template #contentArea>
					<CarClarity
						:car-clarity-loan-details="loanDetails"
						@cancel-button="closeCarClarityModal"
						@proceed-button="closeCarClarityModal"
					/>
				</template>
			</LazyModalsFlexiModal>
		</ClientOnly>
	</div>
</template>

<script setup>
import CarClarity from '@/components/car-clarity/CarClarity.vue'
import LinkWithIcon from '@/components/links/LinkWithIcon.vue'
import IconMoreInfo from '@/assets/svg/product-catalog/ico-moreinfo.svg'
import { useCarClarity } from '@/stores/car-clarity'

const props = defineProps({
	buttonText: {
		type: String,
		default: 'Get a valuation',
		required: false,
	},
	loanDetails: {
		type: Object,
		required: false,
	},
	isButtonFull: {
		type: Boolean,
		default: false,
		required: false,
	},
})

const carClarity = useCarClarity()

const carClarityRef = ref(null)

const showCarClarityModal = ref(false)

const launchWidget = () => {
	carClarity.isPriority = true
	carClarity.showRedirection = false
	showCarClarityModal.value = !showCarClarityModal.value
	carClarity.loan.loanAmount = props.loanDetails.loan_amount
	carClarity.loan.loanTerm = props.loanDetails.loan_term
	carClarity.loan.ballonPct = props.loanDetails.balloon_pct
}

const resetCarClarity = () => {
	carClarity.isPriority = false
	carClarity.clearAndResetTimer()
}

const closeCarClarityModal = () => {
	carClarityRef.value.closeModal()
}
</script>
